import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, XCircleIcon, SmartphoneIcon, HeartCrackIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#1a2342] py-20 md:py-28" data-id="element-157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        {/* The Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-159">
          <div className="flex items-center gap-3 mb-6" data-id="element-160">
            <BrainIcon className="w-8 h-8 text-[#c9a96e]" data-id="element-161" />
            <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#f0ebe3]" data-id="element-162">
              Esto No Es Solo Tristeza
            </h2>
          </div>

          <div className="space-y-5 text-[#f0ebe3]/85 text-lg leading-relaxed" data-id="element-163">
            <p data-id="element-164">
              Lo que estás viviendo no es solo "tristeza por una ruptura". Es
              una{' '}
              <span className="text-[#c9a96e] font-semibold" data-id="element-165">
                respuesta neurobiológica de alto impacto
              </span>
              . Tu cerebro está procesando el rechazo como dolor físico real, y
              tu amígdala ha sido secuestrada por una caída brutal de dopamina.
            </p>
            <p data-id="element-166">
              <span className="text-[#d4a574] font-semibold" data-id="element-167">
                No es que seas débil.
              </span>{' '}
              Es que estás en abstinencia. Tu ex se ha convertido en una droga y
              tu teléfono es el medio para obtener la dosis. Mientras sigas
              conectada a su vida digital, tu cerebro no puede empezar a sanar.
            </p>
            <p className="text-[#c9a96e] font-medium italic" data-id="element-168">
              Estás saboteando tu propia recuperación cada vez que haces clic en
              su perfil.
            </p>
          </div>
        </motion.div>

        {/* Why What You Tried Didn't Work */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-169">
          <h3 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-bold text-[#f0ebe3] mb-8" data-id="element-170">
            Por Qué Lo Que Has Intentado{' '}
            <span className="text-[#c9a96e]" data-id="element-171">No Funciona</span>
          </h3>

          <div className="space-y-6" data-id="element-172">
            <div className="flex gap-4 items-start bg-[#0f1629]/50 p-5 rounded-lg border border-[#c9a96e]/20" data-id="element-173">
              <XCircleIcon className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-174" />
              <div data-id="element-175">
                <p className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-176">
                  <span className="font-semibold text-[#f0ebe3]" data-id="element-177">
                    Tratar de "cerrar el ciclo" hablando con él
                  </span>{' '}
                  solo reabre la herida y te deja mendigando explicaciones que
                  no te darán paz.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-[#0f1629]/50 p-5 rounded-lg border border-[#c9a96e]/20" data-id="element-178">
              <SmartphoneIcon className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-179" />
              <div data-id="element-180">
                <p className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-181">
                  <span className="font-semibold text-[#f0ebe3]" data-id="element-182">
                    Distraerte con amigas o fiestas
                  </span>{' '}
                  no funciona porque, en cuanto hay un segundo de silencio,
                  vuelves a revisar el celular.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-[#0f1629]/50 p-5 rounded-lg border border-[#c9a96e]/20" data-id="element-183">
              <HeartCrackIcon className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-184" />
              <div data-id="element-185">
                <p className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-186">
                  <span className="font-semibold text-[#f0ebe3]" data-id="element-187">
                    Intentar ser "madura" y mantenerlo en redes
                  </span>{' '}
                  es como un alcohólico tratando de dormir con una botella de
                  whisky en la mesa de noche.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start bg-[#0f1629]/50 p-5 rounded-lg border border-[#c9a96e]/20" data-id="element-188">
              <XCircleIcon className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-189" />
              <div data-id="element-190">
                <p className="text-[#f0ebe3]/90 leading-relaxed" data-id="element-191">
                  <span className="font-semibold text-[#f0ebe3]" data-id="element-192">
                    Hacerle "ley del hielo" para que vuelva
                  </span>{' '}
                  es una estrategia de manipulación que te mantiene a TI
                  pendiente de su reacción en lugar de enfocarte en tu paz.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}